import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "label-container" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = {
  key: 0,
  class: "unused-characters"
}

import { VIconSvg } from "@/components";
import { computed, ref } from "vue";
import VErrorTooltip from "../VErrorTooltip/VErrorTooltip.vue";
import { TranslateResult } from "vue-i18n";

interface Props {
  placeholder?: string | TranslateResult;
  label?: string | TranslateResult;
  value?: string;
  rows?: string;
  description?: string | TranslateResult;
  maxLength?: string | number | null;
  showSymbolsCounter?: boolean;
  required?: boolean;
  error?: string | TranslateResult;
  disabled?: boolean;
  readonly?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VTextarea',
  props: {
    placeholder: { default: "" },
    label: { default: "" },
    value: { default: "" },
    rows: { default: "6" },
    description: { default: "" },
    maxLength: { default: "1000" },
    showSymbolsCounter: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    error: { default: "" },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }
  },
  emits: ["input", "blur"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const textarea = ref();

const text = computed({
  get() {
    return props.value;
  },
  set(value) {
    emit("input", value);
  },
});

const isShownInfoIcon = computed(() => !!props.description);

const unusedCharactersLength = computed(() => {
  return props.maxLength ? +props.maxLength - props.value.length : props.value.length;
});

const inputWrapperClasses = computed(() => {
  const classes = {
    "input-required": props.required,
    "input-error": props.error,
  };

  return [classes];
});

const onBlurTextarea = () => {
  emit("blur");
};

const onClickWrapper = () => {
  textarea.value.focus();
};

return (_ctx: any,_cache: any) => {
  const _component_t_textarea = _resolveComponent("t-textarea")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["textarea-container", inputWrapperClasses.value])
  }, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.label), 1),
        (isShownInfoIcon.value)
          ? (_openBlock(), _createBlock(_unref(VIconSvg), {
              key: 0,
              tooltip: _ctx.description,
              name: "InfoCircle2",
              color: "fc-stroke",
              size: "xs"
            }, null, 8, ["tooltip"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showSymbolsCounter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(unusedCharactersLength.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "textarea-wrapper",
      tabindex: "0",
      onClick: onClickWrapper
    }, [
      _createVNode(_component_t_textarea, {
        ref_key: "textarea",
        ref: textarea,
        modelValue: text.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
        maxlength: _ctx.maxLength,
        rows: _ctx.rows,
        class: "textarea",
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        readonly: _ctx.readonly,
        onBlur: onBlurTextarea
      }, null, 8, ["modelValue", "maxlength", "rows", "placeholder", "disabled", "readonly"])
    ]),
    (_ctx.error)
      ? (_openBlock(), _createBlock(VErrorTooltip, {
          key: 0,
          error: _ctx.error
        }, null, 8, ["error"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})